const dietSummaryPanelStrings = {
  noRateForDay: "Ingen sats definert for valgt dag"
};

export default dietSummaryPanelStrings;